import { render, staticRenderFns } from "./FacebookCampaignDialog.vue?vue&type=template&id=1947ab8e"
import script from "./FacebookCampaignDialog.vue?vue&type=script&lang=js"
export * from "./FacebookCampaignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports